import React from "react";
import { useNavigate } from "react-router-dom";

const Breadcrumb = ({ BreadcrumbData }) => {
    
    const navigate = useNavigate();
    
    const handleClick = (path) => {
        navigate(path);
    };

    return (
        <div className="mb-4 text-sm text-gray-500">
            <span key='0'>
                <span
                    className="cursor-pointer font-semibold text-gray-500 hover:no-underline"
                    onClick={() => handleClick('/')}
                >
                    Home
                </span>
                {
                    BreadcrumbData.length > 0
                    &&
                    (
                        <span className="mx-1">{">"}</span>       
                    )
                }
            </span>
            {BreadcrumbData && BreadcrumbData.map((item, index) => (
                <span key={item.id}>
                    <span
                        className="cursor-pointer font-semibold text-gray-500 hover:no-underline"
                        onClick={() => handleClick(item.redirection_end_point)}
                    >
                        {item.category_name_english}
                    </span>
                    {index < BreadcrumbData.length - 1 && <span className="mx-1">{">"}</span>}
                </span>
            ))}
        </div>
    );
};

export default Breadcrumb;
